import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { zPrice, zText } from '../primitives';

export const modifierSchema = z.object({
  displayIndex: z.number().nullable().default(null),
  modifierGroupUuid: z.string(),
  name: z.string(),
  price: z.number().default(0),
  uuid: z.string().default(() => uuidv4()),

  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
});
export type Modifier = z.output<typeof modifierSchema>;

/** Strict schema */
export const modifierStrictSchema = modifierSchema.extend({
  displayIndex: z.int().nullable(),
  modifierGroupUuid: z.guid(),
  name: zText,
  price: zPrice,
  uuid: z.guid(),
});

/** Convex schema */
export const modifierCvxSchema = modifierSchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type ModifierCvx = z.output<typeof modifierCvxSchema>;

// Using a Record to group by modifier group allows for better performance
export const modifiersByModifiersGroupSchema = z.record(
  z.string(),
  z.array(modifierCvxSchema).nullable(),
);
export type ModifiersByModifierGroup = z.output<typeof modifiersByModifiersGroupSchema>;
